export default __webpack_public_path__ + "static/media/06.6cc48f2c.mp3";